
<div class="wrapper">
  <article class="product-table-item row" [ngClass]="{ 'is-in-cart': inCart }">

    <!-- favourite -->
    <div class="favorite" [ngClass]="{'-active': isFavorite}">
      <a (click)="toggleFavorite($event)">
        <i class="fa" [ngClass]="{'fa-heart': isFavorite, 'fa-heart-o': !isFavorite}"></i>
      </a>
    </div>

    <!-- link above cover whole area -->
    <a class="link" *ngIf="hasDetails" (click)="openDetails()"></a>

    <!-- image, text and actionbox -->

      <!-- image -->
      <div class="image-wrapper">
          <div class="image" [appFlyToCart]="product?._id" cartSelector="cartbutton" [ngStyle]="{'background-image': 'url(' + productImage?.modal?.img + '), url(\'/assets/images/no-image-placeholder.png\')'}">
            <!-- aspect ratio  pseudo element -->
        </div>
      </div>

      <!-- text -->
      <div class="text col-xl-6 col-lg-6 col-md-7 col-sm-7 col-5">

        <h3>{{ name }}</h3>

        <p class="productcode">
          {{ displayCode }}
        </p>

        <!-- attributes -->
        <ul class="attributes" *ngIf="catalogItemPageSettings?.showAttributes">
          <ng-container *ngFor="let productParam of product?.attrs">
            <ng-container *ngFor="let param of catalogItemPageSettings?.showAttributes">
              <li *ngIf="productParam.key === param">
                <span> {{ 'entity.label.product.attr.' + productParam.key | lowercase | translate }} </span>
                <span> {{ productParam.value }} </span>
              </li>
            </ng-container>
          </ng-container>
        </ul>

        <!-- facets -->
        <ul class="attributes" *ngIf="catalogItemPageSettings?.showFacets?.length && productFacets?.length">
          <ng-container *ngFor="let productFacet of productFacets">
            <li>
              <span class="-bold"> {{ productFacet?.name }} </span>
              <span>
                    <ng-container *ngFor="let value of productFacet?.values; let i = index; let last = last">
                      <ng-container *ngIf="value">
                        {{ last ? value : value + ', ' }}
                      </ng-container>
                    </ng-container>
                  </span>

            </li>
          </ng-container>
        </ul>

        <!-- price per quantity and staffels -->
        <div *ngIf="hasPrice">
          <p class="minquantity" *ngIf="prices && prices[0]?.minQuantity">
            {{ 'catalog.per-pieces' | translate: {count:  (prices && prices[0]?.minQuantity) } }}
          </p>
     </div>

        <!-- backorder info -->
        <p class="backorder" *ngIf="isProductInBackorder">
          {{ 'product.backorder-info' | translate:{ totalInBackOrder: product?.backorderInfo.totalInBackorder | numberFormat, week: product?.backorderInfo.firstDeliveryDate | momentDateFormat: 'w' } }}
        </p>

        <p class="previously-ordered" *ngIf="isProductPreviouslyOrdered">
          {{ 'product.total-previously-ordered' | translate:{ totalPreviouslyOrdered: product?.totalPreviouslyOrdered | numberFormat } }}
        </p>

        <!-- Stock -->
        <app-stock-info *ngIf="catalogItemPageSettings?.showStockInfo" [product]="product">
        </app-stock-info>

    </div> <!-- // end text -->
    <div class="actionbox col-xl-6 col-lg-6 col-md-5 col-sm-5 col-7">

      <div class="row row-price-and-quantitypicker" *ngIf="hasPrice && canBuy">

        <div class="d-none d-lg-block col-xl-5 col-lg-5 price">

          <span class="amount">
            {{ currentPrice.price | price:currentPrice.currency }}
          </span>
          <span class="legend">
            {{ 'catalog.per-piece' | translate }}
          </span>

          <ul class="pricing-tiers" *ngIf="hasMultiplePrices && prices?.length > 1">
            <li *ngFor="let price of prices | slice: 1; let index = index">
              <span *ngIf="hasMultiplePrices">
                {{ 'catalog.price-from' | translate: {quantity: price?.minQuantity} }} {{ price.price | price:price.currency }}
              </span>
            </li>
          </ul>

        </div>
        <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 quantity">

          <app-quantity-picker-animated
            *ngIf="isTileOrderable && canBuy && showQuantityPickerAnimated"
            [itemId]="product?._id"
            [value]="actualQuantity"
            [minQuantity]="minQuantity"
            (quantityChanged)="addCart($event)"
            [ngClass]="{ 'backorder-mode' : isProductInBackorder }"
            [stepping]="stepping">
          </app-quantity-picker-animated>

          <app-quantity-picker
            *ngIf="isTileOrderable && canBuy && !showQuantityPickerAnimated"
            [itemId]="product?._id"
            [value]="actualQuantity"
            [minQuantity]="minQuantity"
            (quantityChanged)="addCart($event)"
            [stepping]="stepping"
            [quantityType]="quantityPicker"
            [viewType]="'list'">
          </app-quantity-picker>

        </div>
      </div>

    </div> <!-- // end actionbox -->
  </article>
</div>
